import Dashboard from "../../views/dashboard/Dashboard.vue";

const noipcusermanagement = {
  path: "noipcmanagment",
  name: "noipcmanagment",
  redirect: "noipcuserinfo",
  component: Dashboard,
  meta: {
    title: "网络用户",
    icon: "el-icon-menu",
    role: false
  },
  children: [
    {
      path: "/noipcuserinfo",
      name: "noipcuserinfo",
      component: () => import("../../components/noipcuser/userinfo.vue"),
      meta: {
        title: "信息认证",
        icon: "el-icon-s-operation",
        role: false
      }
    },
    {
      path: "/usermanagement",
      name: "usermanagement",
      component: () => import("../../components/noipcuser/usermanagement.vue"),
      meta: {
        title: "人员管理",
        icon: "el-icon-s-operation",
        role: false
      }
    },
    {
      path: "/passrecord",
      name: "passrecord",
      component: () => import("../../components/noipcuser/passrecord.vue"),
      meta: {
        title: "通行记录",
        icon: "el-icon-s-operation",
        role: false
      }
    }
    // {
    //     path: "/equipment",
    //     name: "equipment",
    //     component: () =>
    //         import("../../components/noipcuser/equipment.vue"),
    //     meta: {
    //         title: "设备绑定",
    //         icon: "el-icon-s-operation",
    //         role: false
    //     }
    // },
  ]
};

export default noipcusermanagement;
